var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ECircuitFilter, EPeriod, EPricePeriod, EVolumePeriod, } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import { nifty50 } from "@domains/utils/indexData";
import { SET_PARAMS, } from "../../../interface/iDrivingMarketParams";
export var initCommonState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPeriod.ONE_DAY,
};
export var initPriceState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPricePeriod.THREE_DAY,
};
export var initVolumeState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EVolumePeriod.TODAY,
};
export var initPerformersState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: EPeriod.ONE_WEEK,
};
export var initCircuitState = {
    index: nifty50.sym,
    exchange: nifty50.exc,
    limit: true,
    period: ECircuitFilter.NO_FILTER,
};
var drivingMarketParamsReducer = function (state, action) {
    if (state === void 0) { state = initCommonState; }
    switch (action.type) {
        case SET_PARAMS:
            return __assign(__assign({}, state), action.payload);
        default:
            return __assign({}, state);
    }
};
export default drivingMarketParamsReducer;
